import getAlign from "../../../adapters/getAlign";
import PricingTableProps from "./pricing-table.types";

const pricingTableAdapter = (data: any): PricingTableProps => ({
  title: data.tituloGeneral,
  tags: data.etiquetasArticulo,
  richContent: data.descripcion,
  btnText: data.tituloBoton,
  btnLink: data.redireccionBoton,
  align: getAlign(data.alineacion),
});

export default pricingTableAdapter;
